import React from 'react';

interface RankRingProps {
  level: number;
  progress: number; // 0-100, percent of the way to the next level
  size?: number;
  caption?: string;
}

// Foundation.dc.html's rank-ring chip, animated per Motion.dc.html's
// "ringSweep" (stroke-dashoffset sweep-in on load, plays once).
const RankRing: React.FC<RankRingProps> = ({ level, progress, size = 64, caption }) => {
  const stroke = 5;
  const radius = (size - stroke) / 2;
  const circumference = 2 * Math.PI * radius;
  const clamped = Math.max(0, Math.min(100, progress));
  const offset = circumference * (1 - clamped / 100);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 4 }}>
      <div style={{ position: 'relative', width: size, height: size }}>
        <svg width={size} height={size} style={{ transform: 'rotate(-90deg)' }}>
          <circle cx={size / 2} cy={size / 2} r={radius} fill="none" stroke="var(--border)" strokeWidth={stroke} />
          <circle
            className="ws-ring-sweep"
            cx={size / 2} cy={size / 2} r={radius} fill="none"
            stroke="var(--ember)" strokeWidth={stroke} strokeLinecap="round"
            strokeDasharray={circumference}
            style={{ ['--ring-circumference' as any]: circumference, ['--ring-offset' as any]: offset }}
          />
        </svg>
        <div style={{ position: 'absolute', inset: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <span className="ws-display" style={{ fontSize: size * 0.32, fontWeight: 700, color: 'var(--text-primary)' }}>{level}</span>
        </div>
      </div>
      {caption && <span style={{ fontSize: 11, fontWeight: 600, color: 'var(--text-tertiary)' }}>{caption}</span>}
    </div>
  );
};

export default RankRing;
